import AssetUploader from './AssetUploader';

export default AssetUploader;